import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';
import { NavLink } from 'react-router-dom';

class HalfBasicBackground extends React.Component {

    constructor(props) {
        super(props);
        this.state = { width: 0, height: 0 };
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    };

    render() {

        const { classes } = this.props;

        return (
            <div className={classes.halfHeader}>
                <h1 className={classes.halfHeading}>
                    <NavLink to="/">
                        <img data-test="home" className={classes.largeLogo} src="/images/logo-reversed.png" alt="Logo" />
                    </NavLink>
                    <span style={{ fontFamily: 'Rajdhani', fontSize: 24, marginTop: 100, display: 'block', marginLeft: 160 }}>Knowledge graph management</span>
                </h1>
                {this.state.height > 620 &&
                    <img style={{ position: 'fixed', left: -200, bottom: -290, width: 760 }} src="/images/icon-reversed.png" alt="" />
                }
            </div>
        );
    }
}

HalfBasicBackground.propTypes = {
    classes: PropTypes.object
};

export default withStyles(styles)(HalfBasicBackground);